import '../style/components.css';

export default function Tooltip({children, text}: {children: React.ReactNode, text: string}) {
    return (
        <div className="tooltip">
            {children}
            <span className="tooltiptext">{text}</span>
        </div>
    );
}